import React, {useState} from 'react'
import { Modal, Button, TextArea } from '@arnsbogroup/react-voicearchive'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from './messages'

const BookingRejectModal = ({onReject = () => {}, onClose = () => {}, show = false}) => {

    const { formatMessage } = useIntl()
    const [rejectMessage, setRejectMessage] = useState('')

    return (
        <div>
            <Modal
                show={show}
                onClose={() => onClose()}
                onOutsideClick={() => onClose()}
                title={formatMessage(messages.title)}
                onSubmit={() => onReject(rejectMessage)}
            >
                <TextArea
                    rows={4}
                    value={rejectMessage}
                    onChange={({ target: { value } }) => setRejectMessage(value)}
                    label={formatMessage(messages.rejectMessageLabel)}
                    placeholder={formatMessage(messages.rejectMessagePlaceholder)}
                />
                <Button className="mt-2 float-right" state="negative" onClick={() => onReject(rejectMessage)} >
                    <FormattedMessage {...messages.rejectButton } />
                </Button>
            </Modal>
        </div>
    )
}

export default BookingRejectModal
